module.exports = __webpack_public_path__ + "static/media/logo.0a62c242.png";